import * as React from 'react'
import * as Styled from './MegaForm.styles'

const Dots = ({ numberOfDots = undefined, isLastStep, activeDot }) => {
  // Create an array that we can map over with n (numberOfDots) amount of elements
  const dots = [...Array(numberOfDots).keys()]

  // If numberOfDots is not defined, return the Styled.Dots styled wrapper
  // so that we maintain the spacing that we want but don't render the dots
  if (numberOfDots < 1 || typeof numberOfDots === 'undefined')
    return <Styled.Dots />

  return (
    <Styled.Dots data-testid="dot-navigation">
      {dots.map((dot, i) => (
        <Styled.Dot
          key={dot}
          active={isLastStep ? numberOfDots === i + 1 : activeDot === i + 1}
        />
      ))}
    </Styled.Dots>
  )
}

export default Dots
